const balanceOverTimeData = [
  {
    month: ["2023", "Apr"],
    balanceAvgInPeriod: 375000.0,
    interestAndFees: 0.0,
    debtBalanceBop: 0.0,
    capitalAtRiskEop: 750000.0,
    debtBalanceEop: 750000.0,
    amortization: 0.0,
    disbursement: -750000.0,
    capitalAtRiskAvgInPeriod: 375000.0,
    interestAndFeesCash: 0.0,
    capitalAtRiskBop: 0.0,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "May"],
    balanceAvgInPeriod: 1125000.0,
    interestAndFees: 9375.0,
    debtBalanceBop: 750000.0,
    capitalAtRiskEop: 1490625.0,
    debtBalanceEop: 1500000.0,
    amortization: 0.0,
    disbursement: -750000.0,
    capitalAtRiskAvgInPeriod: 1120312.5,
    interestAndFeesCash: 9375.0,
    capitalAtRiskBop: 750000.0,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Jun"],
    balanceAvgInPeriod: 1500000.0,
    interestAndFees: 18750.0,
    debtBalanceBop: 1500000.0,
    capitalAtRiskEop: 1471875.0,
    debtBalanceEop: 1500000.0,
    amortization: 0.0,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1481250.0,
    interestAndFeesCash: 18750.0,
    capitalAtRiskBop: 1490625.0,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Jul"],
    balanceAvgInPeriod: 1500000.0,
    interestAndFees: 18750.0,
    debtBalanceBop: 1500000.0,
    capitalAtRiskEop: 1453125.0,
    debtBalanceEop: 1500000.0,
    amortization: 0.0,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1462500.0,
    interestAndFeesCash: 18750.0,
    capitalAtRiskBop: 1471875.0,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Aug"],
    balanceAvgInPeriod: 1482839.79,
    interestAndFees: 26096.24,
    debtBalanceBop: 1500000.0,
    capitalAtRiskEop: 1392708.33,
    debtBalanceEop: 1465679.57,
    amortization: 34320.43,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1422916.67,
    interestAndFeesCash: 26096.24,
    capitalAtRiskBop: 1453125.0,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Sep"],
    balanceAvgInPeriod: 1430976.56,
    interestAndFees: 32677.31,
    debtBalanceBop: 1465679.57,
    capitalAtRiskEop: 1290624.99,
    debtBalanceEop: 1396273.54,
    amortization: 69406.03,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1341666.66,
    interestAndFeesCash: 32677.31,
    capitalAtRiskBop: 1392708.33,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Oct"],
    balanceAvgInPeriod: 1360796.82,
    interestAndFees: 31129.9,
    debtBalanceBop: 1396273.54,
    capitalAtRiskEop: 1188541.65,
    debtBalanceEop: 1325320.1,
    amortization: 70953.44,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1239583.32,
    interestAndFeesCash: 31129.9,
    capitalAtRiskBop: 1290624.99,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Nov"],
    balanceAvgInPeriod: 1289052.43,
    interestAndFees: 29547.99,
    debtBalanceBop: 1325320.1,
    capitalAtRiskEop: 1086458.31,
    debtBalanceEop: 1252784.75,
    amortization: 72535.35,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1137499.98,
    interestAndFeesCash: 29547.99,
    capitalAtRiskBop: 1188541.65,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2023", "Dec"],
    balanceAvgInPeriod: 1215708.49,
    interestAndFees: 27930.82,
    debtBalanceBop: 1252784.75,
    capitalAtRiskEop: 984374.97,
    debtBalanceEop: 1178632.23,
    amortization: 74152.52,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1035416.64,
    interestAndFeesCash: 27930.82,
    capitalAtRiskBop: 1086458.31,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Jan"],
    balanceAvgInPeriod: 1140729.35,
    interestAndFees: 26277.59,
    debtBalanceBop: 1178632.23,
    capitalAtRiskEop: 882291.63,
    debtBalanceEop: 1102826.48,
    amortization: 75805.75,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 933333.3,
    interestAndFeesCash: 26277.59,
    capitalAtRiskBop: 984374.97,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Feb"],
    balanceAvgInPeriod: 1064078.56,
    interestAndFees: 24587.5,
    debtBalanceBop: 1102826.48,
    capitalAtRiskEop: 780208.29,
    debtBalanceEop: 1025330.64,
    amortization: 77495.84,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 831249.96,
    interestAndFeesCash: 24587.5,
    capitalAtRiskBop: 882291.63,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Mar"],
    balanceAvgInPeriod: 985718.83,
    interestAndFees: 22859.73,
    debtBalanceBop: 1025330.64,
    capitalAtRiskEop: 678124.95,
    debtBalanceEop: 946107.03,
    amortization: 79223.61,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 729166.62,
    interestAndFeesCash: 22859.73,
    capitalAtRiskBop: 780208.29,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Apr"],
    balanceAvgInPeriod: 905612.08,
    interestAndFees: 21093.44,
    debtBalanceBop: 946107.03,
    capitalAtRiskEop: 576041.61,
    debtBalanceEop: 865117.13,
    amortization: 80989.9,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 627083.28,
    interestAndFeesCash: 21093.44,
    capitalAtRiskBop: 678124.95,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "May"],
    balanceAvgInPeriod: 775198.94,
    interestAndFees: 47246.96,
    debtBalanceBop: 865117.13,
    capitalAtRiskEop: 348958.27,
    debtBalanceEop: 685280.75,
    amortization: 179836.38,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 462499.94,
    interestAndFeesCash: 47246.96,
    capitalAtRiskBop: 576041.61,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Jun"],
    balanceAvgInPeriod: 647279.1,
    interestAndFees: 10455.05,
    debtBalanceBop: 685280.75,
    capitalAtRiskEop: 262499.93,
    debtBalanceEop: 609277.46,
    amortization: 76003.29,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 305729.1,
    interestAndFeesCash: 10455.05,
    capitalAtRiskBop: 348958.27,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Jul"],
    balanceAvgInPeriod: 570809.25,
    interestAndFees: 9521.92,
    debtBalanceBop: 609277.46,
    capitalAtRiskEop: 176041.59,
    debtBalanceEop: 532341.04,
    amortization: 76936.42,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 219270.76,
    interestAndFeesCash: 9521.92,
    capitalAtRiskBop: 262499.93,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Aug"],
    balanceAvgInPeriod: 493395.85,
    interestAndFees: 8567.97,
    debtBalanceBop: 532341.04,
    capitalAtRiskEop: 89583.25,
    debtBalanceEop: 454450.67,
    amortization: 77890.37,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 132812.42,
    interestAndFeesCash: 8567.97,
    capitalAtRiskBop: 176041.59,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Sep"],
    balanceAvgInPeriod: 415017.88,
    interestAndFees: 7592.76,
    debtBalanceBop: 454450.67,
    capitalAtRiskEop: 3124.91,
    debtBalanceEop: 375585.09,
    amortization: 78865.58,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 46354.08,
    interestAndFeesCash: 7592.76,
    capitalAtRiskBop: 89583.25,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Oct"],
    balanceAvgInPeriod: 335653.82,
    interestAndFees: 6595.81,
    debtBalanceBop: 375585.09,
    capitalAtRiskEop: -83333.43,
    debtBalanceEop: 295722.56,
    amortization: 79862.53,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: -40104.26,
    interestAndFeesCash: 6595.81,
    capitalAtRiskBop: 3124.91,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Nov"],
    balanceAvgInPeriod: 255281.7,
    interestAndFees: 5576.63,
    debtBalanceBop: 295722.56,
    capitalAtRiskEop: -169791.77,
    debtBalanceEop: 214840.85,
    amortization: 80881.71,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: -126562.6,
    interestAndFeesCash: 5576.63,
    capitalAtRiskBop: -83333.43,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2024", "Dec"],
    balanceAvgInPeriod: 173879.04,
    interestAndFees: 4534.73,
    debtBalanceBop: 214840.85,
    capitalAtRiskEop: -256250.11,
    debtBalanceEop: 132917.24,
    amortization: 81923.61,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: -213020.94,
    interestAndFeesCash: 4534.73,
    capitalAtRiskBop: -169791.77,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Jan"],
    balanceAvgInPeriod: 91422.87,
    interestAndFees: 3469.6,
    debtBalanceBop: 132917.24,
    capitalAtRiskEop: -342708.45,
    debtBalanceEop: 49928.5,
    amortization: 82988.74,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: -299479.28,
    interestAndFeesCash: 3469.6,
    capitalAtRiskBop: -256250.11,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Feb"],
    balanceAvgInPeriod: 24964.24,
    interestAndFees: 1113.16,
    debtBalanceBop: 49928.5,
    capitalAtRiskEop: -393750.12,
    debtBalanceEop: -0.01,
    amortization: 49928.51,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: -368229.28,
    interestAndFeesCash: 1113.16,
    capitalAtRiskBop: -342708.45,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Mar"],
    balanceAvgInPeriod: 849999.99,
    interestAndFees: 10625.0,
    debtBalanceBop: 849999.99,
    capitalAtRiskEop: 445624.88,
    debtBalanceEop: 849999.99,
    amortization: 0.0,
    disbursement: -850000.0,
    capitalAtRiskAvgInPeriod: 450937.38,
    interestAndFeesCash: 10625.0,
    capitalAtRiskBop: 456249.88,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Apr"],
    balanceAvgInPeriod: 849999.99,
    interestAndFees: 10625.0,
    debtBalanceBop: 849999.99,
    capitalAtRiskEop: 434999.88,
    debtBalanceEop: 849999.99,
    amortization: 0.0,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 440312.38,
    interestAndFeesCash: 10625.0,
    capitalAtRiskBop: 445624.88,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "May"],
    balanceAvgInPeriod: 849999.99,
    interestAndFees: 10625.0,
    debtBalanceBop: 849999.99,
    capitalAtRiskEop: 424374.88,
    debtBalanceEop: 849999.99,
    amortization: 0.0,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 429687.38,
    interestAndFeesCash: 10625.0,
    capitalAtRiskBop: 434999.88,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Jun"],
    balanceAvgInPeriod: 1680551.74,
    interestAndFees: 29575.73,
    debtBalanceBop: 1699999.99,
    capitalAtRiskEop: 1205902.66,
    debtBalanceEop: 1661103.5,
    amortization: 38896.49,
    disbursement: -850000.0,
    capitalAtRiskAvgInPeriod: 1240138.77,
    interestAndFeesCash: 29575.73,
    capitalAtRiskBop: 1274374.88,
    interestAndFeesAccrued: 0.0,
  },
  {
    month: ["2025", "Jul"],
    balanceAvgInPeriod: 1641221.66,
    interestAndFees: 28708.54,
    debtBalanceBop: 1661103.5,
    capitalAtRiskEop: 1137430.44,
    debtBalanceEop: 1621339.82,
    amortization: 39763.68,
    disbursement: 0.0,
    capitalAtRiskAvgInPeriod: 1171666.55,
    interestAndFeesCash: 28708.54,
    capitalAtRiskBop: 1205902.66,
    interestAndFeesAccrued: 0.0,
  },
];

export default balanceOverTimeData;
